import React from 'react'

export default function Bed (props) {
  return (
    <svg viewBox='0 0 64 64' width={props.width || 200} height={props.height || 200} fill={props.color || '#515151'}>
      <path fill={props.color || '#00D8A0'} d='M59.7,49.2H5.9c-2.3,0-3.9-1.6-3.9-3.9c0-2.3,1.6-3.9,3.9-3.9h53.9c2.3,0,3.9,1.6,3.9,3.9C63.6,47.6,62,49.2,59.7,49.2z M21.1,28.9c-2.3,0-3.9-1.6-3.9-3.9v-2.3c0-2.3-1.6-3.9-3.9-3.9H5.1c-2.3,0-3.9-1.6-3.9-3.9s1.6-3.9,3.9-3.9h8.2C19.9,10.9,25,16,25,22.6V25C25,26.9,23.4,28.9,21.1,28.9z' />
      <path fill={props.color || '#444444'} d='M60.1,59.7c-2.3,0-3.9-1.6-3.9-3.9V35.5c0-2.3-1.6-3.9-3.9-3.9h-46c-2.3,0-3.9-1.6-3.9-3.9s1.6-3.9,3.9-3.9h46c6.6,0,11.7,5.1,11.7,11.7v20.3C64,57.8,62,59.7,60.1,59.7L60.1,59.7z' />
      <path fill={props.color || '#444444'} d='M3.9,61.3c-2.3,0-3.9-1.6-3.9-3.9V6.6c0-2.3,1.6-3.9,3.9-3.9s3.9,1.6,3.9,3.9v50.7C7.8,59.3,5.9,61.3,3.9,61.3z' />
    </svg>
  )
}
